export default "__VITE_ASSET__CzxMG9f$__"